import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { Items } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectItems } from '../Selectors/Master/ItemSelectors';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { createJobRateEntry } from '../../Store/PHPSlice/JobRate';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { Print } from '@mui/icons-material';



const JobRateEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        itemId: '',
        cut: '0',
        cut_in: '0',  // Added cut_in field
        cut_out: '0',  // Added cut_out field
        stitch_in: '0',
        stitch_out: '0',
        kaje_in: '0',
        kaje_out: '0',
        press_in: '0',
        press_out: '0',
        embriadary: '0', // Added embriadary field
        screen: '0',    // Added screen field
        print: '0',      // Added Print field
        extra: '0',     
        material: '0',
        total: '0',
        contractor: '0',
        cut_to_pack: '0', // Added cut_to_pack field
        stitch_to_pack: '0', // Added stitch_to_pack field
        userId: userdata?.ID
    });

    const [openDropdowns, setOpenDropdowns] = useState({});
    const [loading, setLoading] = useState(false);
    const actionMap = {
        itemId: fetchItemData
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    useEffect(() => {
        dispatch(fetchItemData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) { 
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        const { cut, cut_in, cut_out, stitch_in, stitch_out, press_in, press_out, kaje_in, kaje_out, embriadary, screen, print, material, extra } = formData;
        const sum = [cut_out, stitch_out, press_out, kaje_out, embriadary, screen, print, material, extra]
            .map(Number)
            .reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0)
            .toFixed(2);
        setFormData(prevData => ({ ...prevData, total: sum }));
    }, [formData]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };





    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const result = await dispatch(createJobRateEntry(formData)).unwrap();
            if (result.msg === 'Already Exits') {
                alert('Already Exits');
                window.location.reload();
            } else {
                // console.log('POST request successful!', result);
                // toast.success("Job Rate Added");
                alert("Job Rate Added");
                window.location.reload();
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };



    const handleNavigateItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownItem = [
        {
            label: 'Item',
            id: 'itemId',
            options: itemList?.data || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('itemId'),
            handleDropdownClose: () => handleDropdownClose('itemId'),
        }
    ];

    return (
        <>
            <Titlebar data={Items} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Item Job Rate Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {/* <Grid item xs={12} md={6}>
                                </Grid> */}


                                {/* item dropdown */}
                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="itemId">Item :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="itemId"
                                                    id="itemId"
                                                    name="itemId"
                                                    value={formData.itemId}
                                                    onChange={(e) => handleDropdownChange(e, 'itemId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        itemList ? itemList.data.map((val, index) => (
                                                            <MenuItem key={index} value={val.ID}>{val.itemNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownItem?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                                }

                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cutting</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cutting-In</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cutting-Out</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Stitching-In</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Stitching-Out</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Kaje-In</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Kaje-Out</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Press-In</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Press-Out</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Embroidery</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Screen</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Print</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Extra</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Material</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Total</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Contractor</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cut To pack</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Stitch To Pack</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>

                                                        {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='cut'
                                                                value={formData.cut}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell> */}
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='cut_in'
                                                                value={formData.cut_in}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='cut_out'
                                                                value={formData.cut_out}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='stitch_in'
                                                                value={formData.stitch_in}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='stitch_out'
                                                                value={formData.stitch_out}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='kaje_in'
                                                                value={formData.kaje_in}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='kaje_out'
                                                                value={formData.kaje_out}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='press_in'
                                                                value={formData.press_in}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='press_out'
                                                                value={formData.press_out}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='embriadary'
                                                                value={formData.embriadary}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='screen'
                                                                value={formData.screen}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='print'
                                                                value={formData.print}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='extra'
                                                                value={formData.extra}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='material'
                                                                value={formData.material}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>

                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                value={formData.total}
                                                                inputProps={{ style: styled.inputTable, readOnly: true }}
                                                            />
                                                        </TableCell>
                                                        {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='contractor'
                                                                value={formData.contractor}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell> */}
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='cut_to_pack'
                                                                value={formData.cut_to_pack}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='stitch_to_pack'
                                                                value={formData.stitch_to_pack}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default JobRateEntry;
